module.exports = __webpack_public_path__ + "img/icon-checkbox.706a52c.svg";